// src/stores/cashbox.js
import { defineStore } from 'pinia'
import apiService from '@/services/apiService'

export const useCashboxStore = defineStore('cashbox', {
// Estado inicial (añade nombreUsuario)
state: () => ({
  isOpen        : false,
  aperturaId    : null,
  fechaApertura : null,
  montoInicial  : null,
  nombreUsuario : '',
  igresos_dia   : 0,
  egresos_dia   : 0,
  saldo_en_caja : 0,
  facturas_pendientes : 0,
  sucursalId: null,
  cajaId: null,
  contextMessage: ''
}),
actions: {
  resetContext(message = '') {
    this.isOpen = false
    this.aperturaId = null
    this.fechaApertura = null
    this.montoInicial = null
    this.nombreUsuario = ''
    this.igresos_dia = 0
    this.egresos_dia = 0
    this.saldo_en_caja = 0
    this.facturas_pendientes = 0
    this.sucursalId = null
    this.cajaId = null
    this.contextMessage = message
  },
  async fetchCurrentOpen(params = {}) {
    try {
      const res = await apiService.get('/api/cashbox/open/current/', params)
      if (res.data.success) {
        const d = res.data.data
        this.isOpen        = true
        this.aperturaId    = d.apertura_id
        this.fechaApertura = d.apertura
        this.montoInicial  = parseFloat(d.monto_inicial)
        this.nombreUsuario = d.usuario
        this.igresos_dia   = parseFloat(d.ingresos_dia)
        this.egresos_dia   = parseFloat(d.egresos_dia)
        this.saldo_en_caja = parseFloat(d.saldo_en_caja)
        this.facturas_pendientes = d.facturas_pendientes
        this.sucursalId = d.sucursal_id ? Number(d.sucursal_id) : null
        this.cajaId = d.caja_id ? Number(d.caja_id) : null
        this.contextMessage = ''
      } else {
        this.resetContext()
      }
    } catch (err) {
      // Silenciar errores cuando no hay caja abierta (es un estado normal)
      console.log('No hay caja abierta para el usuario actual')
      this.resetContext(err?.response?.data?.message || '')
    }
  }
}

})
